<template>
    <!-- Used in-page AND inside the floating (picture-in-picture) panel, whose separate document only has
         AIFloatingRecorder's panelStyles: the drawing styles itself with SVG attributes, and the panel
         repeats the few .share-guide rules below. -->
    <div class="share-guide">
        <svg viewBox="0 0 300 196" role="img" aria-label="Chrome’s share picker: the Entire Screen tab, the Share with system audio switch turned on under the screen previews, and the Share with audio button" font-family="'Segoe UI', system-ui, -apple-system, sans-serif">
            <rect x="1" y="1" width="298" height="194" rx="8" fill="#ffffff" stroke="#c4c7cc" />
            <text x="12" y="17" font-size="9.5" fill="#202124" font-weight="600">Choose what to share with superform.ironbook.com</text>
            <!-- tabs -->
            <text x="12" y="37" font-size="10" fill="#5f6368">Chrome Tab</text>
            <text x="82" y="37" font-size="10" fill="#5f6368">Window</text>
            <text x="134" y="37" font-size="10" fill="#1a73e8" font-weight="700">Entire Screen</text>
            <line x1="1" y1="44.5" x2="299" y2="44.5" stroke="#dadce0" />
            <rect x="132" y="42" width="70" height="3" fill="#1a73e8" />
            <rect x="127" y="23" width="81" height="25" rx="6" fill="none" stroke="#ea6a0e" stroke-width="2" />
            <circle cx="220" cy="35" r="8" fill="#c2410c" /><text x="220" y="38.5" font-size="10" font-weight="700" fill="#fff" text-anchor="middle">1</text>
            <!-- two screens, the first selected -->
            <rect x="12" y="53" width="126" height="50" rx="4" fill="#e8f0fe" stroke="#1a73e8" stroke-width="2" />
            <rect x="19" y="58" width="112" height="40" rx="2" fill="#3c4043" />
            <rect x="25" y="63" width="58" height="29" rx="1.5" fill="#8ab4f8" />
            <rect x="88" y="63" width="37" height="18" rx="1.5" fill="#e8eaed" />
            <text x="75" y="114" font-size="8.5" fill="#3c4043" text-anchor="middle">Screen 1</text>
            <rect x="150" y="53" width="126" height="50" rx="4" fill="#f8f9fa" stroke="#dadce0" />
            <rect x="157" y="58" width="112" height="40" rx="2" fill="#5f6368" />
            <rect x="163" y="63" width="45" height="29" rx="1.5" fill="#bdc1c6" />
            <text x="213" y="114" font-size="8.5" fill="#3c4043" text-anchor="middle">Screen 2</text>
            <!-- system audio switch row, under the previews -->
            <rect x="7" y="121" width="258" height="26" rx="13" fill="#fff4ea" stroke="#ea6a0e" stroke-width="2" />
            <path d="M16 131h3.5l4.5-4v14l-4.5-4H16z" fill="#3c4043" />
            <path d="M26.5 130.5q3 3.5 0 7M28.8 128.2q5 5.8 0 11.6" fill="none" stroke="#3c4043" stroke-width="1.2" stroke-linecap="round" />
            <text x="37" y="137.5" font-size="10" fill="#202124">Share with system audio</text>
            <rect x="232" y="128.5" width="22" height="11" rx="5.5" fill="#1a73e8" />
            <circle cx="248.5" cy="134" r="4" fill="#ffffff" />
            <circle cx="278" cy="134" r="8" fill="#c2410c" /><text x="278" y="137.5" font-size="10" font-weight="700" fill="#fff" text-anchor="middle">2</text>
            <!-- buttons (Windows order) -->
            <rect x="147" y="161" width="92" height="27" rx="13.5" fill="none" stroke="#ea6a0e" stroke-width="2" />
            <rect x="150" y="164" width="86" height="21" rx="10.5" fill="#1a73e8" />
            <text x="193" y="177.5" font-size="9" fill="#ffffff" font-weight="700" text-anchor="middle">Share with audio</text>
            <rect x="244" y="164" width="48" height="21" rx="10.5" fill="#ffffff" stroke="#dadce0" />
            <text x="268" y="177.5" font-size="9" fill="#1a73e8" text-anchor="middle">Cancel</text>
            <circle cx="133" cy="174.5" r="8" fill="#c2410c" /><text x="133" y="178" font-size="10" font-weight="700" fill="#fff" text-anchor="middle">3</text>
        </svg>
        <ol class="share-steps">
            <li><b aria-hidden="true">1</b><span>Click <strong>Entire Screen</strong></span></li>
            <li><b aria-hidden="true">2</b><span>Turn on <strong>Share with system audio</strong></span></li>
            <li><b aria-hidden="true">3</b><span>Click <strong>Share with audio</strong></span></li>
        </ol>
        <p v-if="note" class="share-note">{{ note }}</p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// How to share a screen WITH the call's sound in Chrome's picker (drawn after the Windows picker,
// where system audio is offered for Entire Screen; matches Keelan’s Chrome, Oct 2026).
export default defineComponent({
    name: 'AIShareGuide',
    props: { note: { type: String, default: '' } }
});
</script>

<style scoped>
.share-guide svg { display: block; width: 100%; max-width: 360px; height: auto; }
.share-steps { list-style: none; padding: 0; margin: 10px 0 0; display: grid; gap: 6px; font-size: 13px; color: #34261c; }
.share-steps li { display: flex; align-items: center; gap: 8px; }
.share-steps b { flex: 0 0 20px; height: 20px; border-radius: 50%; background: #c2410c; color: #fff; font-size: 11px; display: inline-flex; align-items: center; justify-content: center; }
.share-note { margin: 8px 0 0; font-size: 12px; font-weight: 600; color: #8a3a0b; }
</style>
